@if (showButtons) {
  <div>
    <!-- Area Education -->
    <div  class="scrollable mt-2 row z-top " [ngStyle]="educationStyle">
      <button (click)="checkPlanBeforeRedirect('education-area')" class="imgWhite"
        (mouseenter)="showSidebarEducation=true" (mouseleave)="showSidebarEducation=false">
        <img src="/assets/images/icons/education-outline.svg" class="upgrade-piano-icon"
          (mouseenter)="showSidebarEducation=true">
      </button>
    </div>
    @if (showSidebarEducation) {
      <div class="scrollable mt-2 row no-gutters"
        [ngClass]="{'enlarge-education': showSidebarEducation}" [@enterAnimation] [ngStyle]="educationStyle">
        <div class="border-box border-box-education">
          {{'header.education-area'| translate}}
        </div>
      </div>
    }
    <!-- Glossario -->
    <div class="scrollable mt-2 row z-top " [ngStyle]="glossaryStyle">
      <button (click)="checkPlanBeforeRedirect('glossary')" class="imgWhite" (mouseenter)="showSidebarGlossary=true"
        (mouseleave)="showSidebarGlossary=false">
        <img src="/assets/images/icons/glossario.svg" class="upgrade-piano-icon"
          (mouseenter)="showSidebarGlossary=true">
      </button>
    </div>
    @if (showSidebarGlossary) {
      <div class="scrollable mt-2 row no-gutters"
        [ngClass]="{'enlarge-glossary': showSidebarGlossary}" [@enterAnimation]
        (click)="checkPlanBeforeRedirect('glossary')" [ngStyle]="glossaryStyle">
        <div class="border-box border-box-glossary">
          {{'header.glossary'| translate}}
        </div>
      </div>
    }
    <!-- Live Assistant -->
    @if (liveAssistantEnbaled && widgetLiveAssistantEnabled) {
      <div
        class="scrollable mt-2 row z-top"
        [ngStyle]="videoconferenceStyle"
        >
        <button
          (click)="goToVideoconferenceList()"
          class="imgWhite"
          (mouseenter)="showSidebarVideoconference = true"
          (mouseleave)="showSidebarVideoconference = false"
          >
          <img
            src="/assets/images/icons/stewardship-outline.svg"
            class="upgrade-piano-icon"
            (mouseenter)="showSidebarVideoconference = true"
            />
        </button>
      </div>
    }
    @if (showSidebarVideoconference) {
      <div class="scrollable mt-2 row no-gutters" [ngStyle]="videoconferenceStyle"
        [ngClass]="{'enlarge-videoconference': showSidebarVideoconference}" [@enterAnimation]>
        <div class="border-box border-box-videoconference">
          {{'header.live-assistant'| translate}}
        </div>
      </div>
    }
    <!-- FAQ -->
    @if (isCoeSection || !isUserSmart) {
      <div class="scrollable mt-2 row z-top " [ngStyle]="faqStyle">
        <button (click)="checkPlanBeforeRedirect('faq')" class="imgOrange" (mouseenter)="showSidebarHelp=true"
          (mouseleave)="showSidebarHelp=false">
          <img src="/assets/images/icons/help-question-outline.svg" class="upgrade-piano-icon"
            (mouseenter)="showSidebarHelp=true">
        </button>
      </div>
    }
    @if (showSidebarHelp) {
      <div class="scrollable mt-2 row no-gutters" [ngClass]="{'enlarge-help': showSidebarHelp}"
        [@enterAnimation] [ngStyle]="faqStyle">
        <div class="border-box border-box-upgrade-plan">
          {{'header.faq'| translate}}
        </div>
      </div>
    }
  </div>
}

<app-upgrade-plan-modal #upgradeModal></app-upgrade-plan-modal>

<pwc-modal #upgradeMessageHeaderModal [id]="'upgradeMessageHeaderModal'">
  <div modal-title>
    <h5>{{'header.startup-modal.title' | translate}}</h5>
  </div>

  <div modal-body>
    <div>
      <div>
        <p class="startup-message-text">
          {{'header.startup-modal.message-1' | translate}}
          <br><br>
          {{'header.startup-modal.message-2' | translate}}
        </p>
      </div>
    </div>
  </div>

  <div modal-footer class="text-end">
    <button type="button" class="btn btn-action btn-success ms-2" (click)="upgradeMessageHeaderModal.close()">
      {{'confirm-modal.confirm-btn' | translate}}
    </button>
  </div>
</pwc-modal>
